import { render } from "./ActiveProjects.vue?vue&type=template&id=096e4dc3&scoped=true"
import script from "./ActiveProjects.vue?vue&type=script&lang=js"
export * from "./ActiveProjects.vue?vue&type=script&lang=js"

import "./ActiveProjects.vue?vue&type=style&index=0&id=096e4dc3&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/user.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096e4dc3"]])

export default __exports__